<template>
  <section class="merge-request-approve-form">
    <div class="merge-request-approve-form__info">
      <b>{{ $t('approves.title') }}</b>
      <div
        v-if="hasApprovers"
        class="approvers"
      >
        <user-label-item
          v-for="user in mergeRequestApprovers.approvers"
          :key="user.id"
          :show-tooltip="true"
          :has-user-link="true"
          :show-name="false"
          :user="user"
          tooltip-prefix="total-prefix-approves"
        />
      </div>
      <div
        v-else
        class="approvers --none"
      >
        <small>{{ $t('approves.none') }}</small>
      </div>
    </div>
    <div
      v-if="canApprove"
      class="merge-request-approve-form__actions"
    >
      <gf-button
        v-if="isApprovedModel !== null"
        class="approve-button"
        :variant="actionButtonVariant"
        :text="actionButtonText"
        @click="approveMergeRequest"
      />
    </div>
  </section>
</template>

<script>
import ACTION_ENUM from '@shared/modules/custom-roles/custom-roles.constants';
import MergeRequestService from '@shared/modules/merge-request/merge-request.service';
import UserLabelItem from '@shared/shared-components/shared/user-label-item';
// eslint-disable-next-line max-len
import MergeRequestApproverService from '@/shared-modules/modules/merge-request-approver/merge-request-approver.service';
import GfButton from '@/shared-modules/shared-components/shared/components/GfButton';
// eslint-disable-next-line max-len
import MergeRequestApprovalMessages from '@/shared-modules/modules/merge-request-approver/merge-request-approval.messages';

export default {
  name: 'MergeRequestApproveForm',
  components: {
    GfButton,
    UserLabelItem
  },
  data() {
    return {
      isApprovedModel: null
    };
  },
  computed: {
    canApprove() {
      return (
        this.getActionAvailabilityFlag(ACTION_ENUM.APPROVE_MERGE_REQUEST) &&
        this.mergeRequest?.status &&
        !['CLOSED', 'MERGED', 'CANCELED'].includes(this.mergeRequest?.status?.id)
      );
    },
    ACTION_ENUM() {
      return ACTION_ENUM;
    },
    mergeRequest() {
      return this.$store.getters.getSelectedMergeRequest;
    },
    alias() {
      return this.$route.params?.alias;
    },
    projectAlias() {
      return this.$route.params?.projectAlias;
    },
    mergeRequestId() {
      return this.$route.params?.id;
    },
    actionButtonVariant() {
      return this.isApprovedModel ? 'outline-danger' : 'success';
    },
    actionButtonText() {
      return this.isApprovedModel
        ? this.$t('approves.cancel_approve')
        : this.$t('approves.approve');
    },
    mergeRequestApprovers() {
      return this.$store.getters.getMergeRequestApprovedBy;
    },
    applicationVersion() {
      return this.$store.getters.getApplicationVersion;
    },
    hasApprovers() {
      return (
        this.mergeRequestApprovers &&
        this.mergeRequestApprovers.approvers &&
        this.mergeRequestApprovers.approvers.length > 0
      );
    }
  },
  mounted() {
    this.getMergeRequestApprovers();
    if (this.canApprove) {
      this.isMergeRequestApprovedByUser();
    }
  },
  methods: {
    getActionAvailabilityFlag(action) {
      return this.$store.getters.getActionAvailabilityFlag(action);
    },
    getMergeRequestApprovers() {
      MergeRequestApproverService.getMergeRequestApprovedBy(
        this.alias,
        this.projectAlias,
        this.mergeRequestId
      );
    },
    isMergeRequestApprovedByUser() {
      MergeRequestApproverService.getMergeRequestApprovedByMe(
        this.alias,
        this.projectAlias,
        this.mergeRequestId
      ).then((res) => {
        this.isApprovedModel = res?.approved;
      });
    },
    getMergeRequestCodeOwners() {
      MergeRequestService.getMergeRequestCodeOwners(
        this.alias,
        this.projectAlias,
        this.mergeRequestId
      );
    },
    approveMergeRequest() {
      MergeRequestApproverService.approveRequest(
        this.alias,
        this.projectAlias,
        this.mergeRequestId
      ).then(() => {
        this.isApprovedModel = !this.isApprovedModel;
        this.getMergeRequestApprovers();
        if (this.applicationVersion !== 'onpremise') {
          this.getMergeRequestCodeOwners();
        }
        this.$emit('update');
      });
    }
  },
  i18n: {
    messages: MergeRequestApprovalMessages
  }
};
</script>

<style lang="scss">
$this: '.merge-request-approve-form';

#{$this} {
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background-color: var(--light);
  border: 1px solid var(--border-color);
  border-radius: 6px;

  #{$this}__info {
    display: flex;
    flex-direction: column;
    gap: 6px;

    & > .approvers {
      display: flex;
      flex-wrap: wrap;
      gap: 4px;

      &.--none {
        color: var(--text-muted);
      }
    }
  }
  #{$this}__actions {
    display: flex;
    justify-content: flex-end;

    & > .approve-button {
      width: 100%;

      @include theme.max-lg {
        width: auto;
      }

      @include theme.max-sm {
        width: 100%;
      }
    }
  }
}
</style>
